import type { PlatformSchoolDetailTabKey } from "../types/platformSchoolDetail.types";

export const PLATFORM_SCHOOL_DETAIL_TABS: PlatformSchoolDetailTabKey[] = [
  "overview",
  "teachers",
  "students",
  "staff",
];
